import { useGetDashboardAnalysisLinkWithState } from '@modules/dashboard/hooks';
import { Link, Stack } from '@mui/material';
import { AnalysisViewFragment } from 'generated/graphql';
import { Link as RouterLink } from 'react-router-dom';

interface DashboardAnalysisTitleProps {
  analysis: AnalysisViewFragment;
}

export const DashboardAnalysisTitle = ({
  analysis,
}: DashboardAnalysisTitleProps) => {
  const { analysisLink, analysisLinkState } =
    useGetDashboardAnalysisLinkWithState(analysis);

  return (
    <Stack
      direction="row"
      spacing={1}
      alignItems="center"
      onClick={(e) => e.stopPropagation()}
    >
      <Link
        variant="subtitle1"
        className="dashboard-analysis-title"
        component={RouterLink}
        to={analysisLink}
        state={analysisLinkState}
        sx={{
          textDecoration: 'none',
          color: 'text.primary',
          '&:hover': {
            textDecoration: 'underline',
            color: 'primary.main',
          },
        }}
      >
        {analysis.title}
      </Link>
    </Stack>
  );
};
